export default {
  namespaced: true,
  video_tour: {
    name: "Nombre",
    time_interval: "Intervalo de tiempo",
    time_interval_description: "Intervalo de tiempo en segundos",
    preview: "Vista previa",
    preview_message: "Haga clic en un elemento para ver una vista previa.",
    success: "Video tour guardado con exito",
    views_list: "Lista de vistas",
    selected_views: "Vistas seleccionadas",
    items_selected: "Elementos seleccionados",
    confirm_delete: "¿Está seguro de que desea eliminar el video tour '%tour%'?",
    success_delete: "Video tour eliminado correctamente",
    layouts_list: "Lista de layouts"
  },
};
